import { Route, Routes } from 'react-router-dom';
import { NotificationsPage } from '@/modules/notifications/pages/NotificationsPage';

export function NotificationsModule() {
  return (
    <Routes>
      <Route index element={<NotificationsPage />} />
    </Routes>
  );
}

export { NotificationDropdown } from '@/modules/notifications/components/NotificationDropdown';
